import { toast } from 'bulma-toast';
import { NgModule } from '@angular/core';

import { ToastService } from './services';

@NgModule({
    providers: [
        ToastService,
        {
            provide: 'toast',
            useValue: toast,
        }
    ]
})

export class ToastModule {}
